import { render, staticRenderFns } from "./BatchImportTask.vue?vue&type=template&id=2d34e777&scoped=true"
import script from "./BatchImportTask.vue?vue&type=script&lang=js"
export * from "./BatchImportTask.vue?vue&type=script&lang=js"
import style0 from "./BatchImportTask.vue?vue&type=style&index=0&id=2d34e777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d34e777",
  null
  
)

export default component.exports